import * as React from 'react';
import { EditComponent, CreateComponent, CustomComponentProps } from 'src/components/common/Component';

export function MakerEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function MakerCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"maker"} children={children} />
    );
}